import React, { useState, useEffect } from 'react';
import { FiUser, FiMail, FiLock, FiSave, FiShield, FiPhone } from 'react-icons/fi';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const libelleRole = (role) => {
  if (role === 'admin') return 'Administrateur';
  if (role === 'agent') return 'Agent';
  return 'Consultation';
};

const ProfilPage = () => {
  const { user, updateUser } = useAuth();

  const [identite, setIdentite] = useState({ prenom: '', nom: '', telephone: '' });
  const [courriel, setCourriel] = useState({ email: '', mot_de_passe: '' });
  const [secret, setSecret] = useState({
    mot_de_passe_actuel: '',
    nouveau_mot_de_passe: '',
    confirmation: '',
  });

  const [envoiIdentite, setEnvoiIdentite] = useState(false);
  const [envoiCourriel, setEnvoiCourriel] = useState(false);
  const [envoiSecret, setEnvoiSecret] = useState(false);

  useEffect(() => {
    if (user) {
      setIdentite({
        prenom: user.prenom || '',
        nom: user.nom || '',
        telephone: user.telephone || '',
      });
      setCourriel((c) => ({ ...c, email: user.email || '' }));
    }
  }, [user]);

  const enregistrerIdentite = async (e) => {
    e.preventDefault();
    setEnvoiIdentite(true);
    try {
      const charge = { nom: identite.nom, prenom: identite.prenom };
      if (identite.telephone) charge.telephone = identite.telephone;
      const res = await authAPI.updateProfile(charge);
      updateUser(res.data.user);
      toast.success('Informations mises a jour');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erreur lors de la mise a jour');
    } finally {
      setEnvoiIdentite(false);
    }
  };

  const enregistrerCourriel = async (e) => {
    e.preventDefault();
    if (!courriel.mot_de_passe) {
      toast.error('Saisissez votre mot de passe pour confirmer');
      return;
    }
    setEnvoiCourriel(true);
    try {
      const res = await authAPI.changeEmail(courriel);
      if (res.data.token) localStorage.setItem('authToken', res.data.token);
      updateUser(res.data.user);
      setCourriel({ email: res.data.user.email, mot_de_passe: '' });
      toast.success('Adresse email de connexion modifiee');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erreur lors de la modification');
    } finally {
      setEnvoiCourriel(false);
    }
  };

  const enregistrerSecret = async (e) => {
    e.preventDefault();
    if (secret.nouveau_mot_de_passe !== secret.confirmation) {
      toast.error('Les deux nouveaux mots de passe ne correspondent pas');
      return;
    }
    if (secret.nouveau_mot_de_passe.length < 10) {
      toast.error('Le nouveau mot de passe doit contenir au moins 10 caracteres');
      return;
    }
    setEnvoiSecret(true);
    try {
      await authAPI.changePassword({
        mot_de_passe_actuel: secret.mot_de_passe_actuel,
        nouveau_mot_de_passe: secret.nouveau_mot_de_passe,
      });
      setSecret({ mot_de_passe_actuel: '', nouveau_mot_de_passe: '', confirmation: '' });
      toast.success('Mot de passe modifie avec succes');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erreur lors de la modification');
    } finally {
      setEnvoiSecret(false);
    }
  };

  const force = (v) => {
    let n = 0;
    if (v.length >= 10) n += 1;
    if (v.length >= 14) n += 1;
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) n += 1;
    if (/[0-9]/.test(v)) n += 1;
    if (/[^A-Za-z0-9]/.test(v)) n += 1;
    return n;
  };
  const niveau = force(secret.nouveau_mot_de_passe);
  const motsForce = ['Tres faible', 'Faible', 'Moyen', 'Bon', 'Solide', 'Excellent'];

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="page-content" id="page-content">
          <div className="page-header">
            <h1 className="page-title">Mon profil</h1>
          </div>

          <div className="profil-entete card">
            <div className="profil-avatar">
              {(user?.prenom || user?.email || '?').charAt(0).toUpperCase()}
            </div>
            <div className="profil-identite">
              <h2>{user?.prenom} {user?.nom}</h2>
              <p>{user?.email}</p>
              <span className="profil-badge"><FiShield /> {libelleRole(user?.role)}</span>
            </div>
          </div>

          <div className="profil-grille">

            <div className="card profil-carte">
              <div className="card-header"><h3><FiUser /> Informations personnelles</h3></div>
              <form onSubmit={enregistrerIdentite} className="profil-form">
                <div className="form-group">
                  <label className="form-label">Prenom</label>
                  <input
                    type="text"
                    value={identite.prenom}
                    onChange={(e) => setIdentite({ ...identite, prenom: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Nom</label>
                  <input
                    type="text"
                    value={identite.nom}
                    onChange={(e) => setIdentite({ ...identite, nom: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label"><FiPhone /> Telephone</label>
                  <input
                    type="tel"
                    value={identite.telephone}
                    onChange={(e) => setIdentite({ ...identite, telephone: e.target.value })}
                    placeholder="+224 6XX XX XX XX"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={envoiIdentite}>
                  <FiSave /> {envoiIdentite ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </form>
            </div>

            <div className="card profil-carte">
              <div className="card-header"><h3><FiMail /> Adresse de connexion</h3></div>
              <form onSubmit={enregistrerCourriel} className="profil-form">
                <p className="profil-aide">
                  Cette adresse est votre identifiant de connexion a OGP IMMO.
                </p>
                <div className="form-group">
                  <label className="form-label">Nouvelle adresse email</label>
                  <input
                    type="email"
                    value={courriel.email}
                    onChange={(e) => setCourriel({ ...courriel, email: e.target.value })}
                    required
                    autoComplete="username"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Mot de passe actuel (confirmation)</label>
                  <input
                    type="password"
                    value={courriel.mot_de_passe}
                    onChange={(e) => setCourriel({ ...courriel, mot_de_passe: e.target.value })}
                    required
                    autoComplete="current-password"
                    placeholder="Pour confirmer votre identite"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={envoiCourriel}>
                  <FiSave /> {envoiCourriel ? 'Modification...' : 'Modifier l adresse'}
                </button>
              </form>
            </div>

            <div className="card profil-carte">
              <div className="card-header"><h3><FiLock /> Mot de passe</h3></div>
              <form onSubmit={enregistrerSecret} className="profil-form">
                <p className="profil-aide">
                  Minimum 10 caracteres. Melangez majuscules, minuscules, chiffres et symboles.
                </p>
                <div className="form-group">
                  <label className="form-label">Mot de passe actuel</label>
                  <input
                    type="password"
                    value={secret.mot_de_passe_actuel}
                    onChange={(e) => setSecret({ ...secret, mot_de_passe_actuel: e.target.value })}
                    required
                    autoComplete="current-password"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Nouveau mot de passe</label>
                  <input
                    type="password"
                    value={secret.nouveau_mot_de_passe}
                    onChange={(e) => setSecret({ ...secret, nouveau_mot_de_passe: e.target.value })}
                    required
                    minLength={10}
                    autoComplete="new-password"
                  />
                  {secret.nouveau_mot_de_passe && (
                    <div className="profil-force">
                      <div className="profil-force-barre">
                        <span style={{ width: (niveau * 20) + '%' }} data-niveau={niveau}></span>
                      </div>
                      <small>{motsForce[niveau]}</small>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label className="form-label">Confirmer le nouveau mot de passe</label>
                  <input
                    type="password"
                    value={secret.confirmation}
                    onChange={(e) => setSecret({ ...secret, confirmation: e.target.value })}
                    required
                    autoComplete="new-password"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={envoiSecret}>
                  <FiLock /> {envoiSecret ? 'Modification...' : 'Changer le mot de passe'}
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilPage;
